export default "__VITE_ASSET__bS3BkM3p__"